<section class="container">
  @if (tenantService.selectedTenant) {
    <div>
      <div class="header-wrapper">
        <h1>Overview</h1>
      </div>
      @if (showTenantSpecificConfiguration) {
        <div class="content-wrapper">
          <h3>Tenant Specific Configuration</h3>
          <table class="mdl-data-table">
            <thead>
              <tr>
                <th>Setting</th>
                <th>Value</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>Session Timeout</td>
                <td><span>{{tenantSessionTimeout}} minutes</span>@if (showSessionMaxLengthText) {
                <span> - Values over 48 hours (web)/30 days (mobile) are ignored and the default is used instead.</span>
              }</td>
            </tr>
          </tbody>
        </table>
      </div>
    }
    <div class="content-wrapper">
      <h3>Latest Releases</h3>
      @if (loading) {
        <div class="loading">
          <aw-spinner></aw-spinner>
        </div>
      }
      @if (!loading && !hasReleases) {
        <div>
          There are no releases for this tenant.
        </div>
      }
      @if (!loading && hasReleases) {
        <table class="mdl-data-table">
          <thead>
            <tr>
              <th>Release #</th>
              <th>Release Date</th>
              <th>Release Notes</th>
            </tr>
          </thead>
          <tbody>
            @for (release of releases; track release) {
              <tr>
                <td><a [routerLink]="['../releases', release.ReleaseNumber]">{{ release.ReleaseNumber }}</a></td>
                <td>{{ release.ReleaseDate | date : 'dd/MM/yyyy HH:mm:ss' }}</td>
                <td>{{ release.ReleaseNotes }}</td>
              </tr>
            }
          </tbody>
        </table>
      }
    </div>
  </div>
}
@if (!tenantService.selectedTenant) {
  <div>
    <div class="content-wrapper">
      <h3>Please select a Tenant</h3>
    </div>
  </div>
}
</section>
